import React, { Component } from 'react';
import throttle from 'lodash/throttle';
import * as utils from './utils';
import Img from 'components/common/Img';

class OverlapStack extends Component {
	constructor(props) {
		super(props);
		this.state = {
			orders: [0],
			rotations: [0],
		}
		this.xStart = 0;
		this.xEnd = 9999;
		this.elRefs = [];
	}
	componentDidMount() {
		this.setState({
			orders: utils.getReversedArray( this.props.list.length ),
			rotations: utils.getListOfRotations( this.props.list.length, 5 ),
		});
		window.addEventListener('resize', this.throttledResize);
		this.recalc();
	}
	componentWillUnmount() {
		window.removeEventListener('resize', this.throttledResize);
	}
	recalc = (e) => {
		let xStart;
		let xEnd;
		this.elRefs.forEach( ref => {
			const bound = ref.current.getBoundingClientRect();
			xStart = (xStart) ? Math.min(bound.left, xStart)  : bound.left;
			xEnd   = (xEnd)   ? Math.max(bound.right, xEnd)   : bound.right;
		} );
		this.xStart = xStart;
		this.xEnd = xEnd;
	}
	throttledResize = throttle( this.recalc, 200 );
	moveToTop = ( itemIndex ) => {
		const newOrder = utils.setIndexToHighest( this.state.orders, itemIndex );
		if (newOrder) this.setState({orders: newOrder});
	}
	findAndPromote = (e) => {
		const obj = e.touches ? e.touches[0] : e;
		const x = obj.clientX;
		const percentage = (x - this.xStart) / (this.xEnd - this.xStart);
		const index = Math.round( percentage * (this.props.list.length - 1) );
		this.moveToTop( index );
	}
	render() {
		if ( !this.props.list ) return null;
		
		const wrapperStyle = { 
			position: 'relative', 
			height: 0, 
			paddingBottom: '100%',
		};
		const items = this.props.list.map( (item, index) => {
			const rotation = this.state.rotations[index];
			const zIndex = this.state.orders[index] || 0;
			this.elRefs[index] = this.elRefs[index] || React.createRef();
			return (
				<div ref={this.elRefs[index]} key={index}>
					<StackItem image={item.image} rotation={rotation} zIndex={zIndex} />
				</div>
			)
		} );
		return (
			<div className="Stack" style={wrapperStyle} 
				onMouseMove={this.findAndPromote} onTouchMove={this.findAndPromote}>
				{items}
			</div>
		)
	}
}

class StackItem extends Component {
	render() {
		const { image, rotation, zIndex } = this.props;
		const { src, width, height } = image;
		const diagonal = Math.sqrt( width * width + height * height );
		const siStyle = { 
			position: 'absolute',
			width: (width / diagonal * 100) + '%',
			height: (height / diagonal * 100) + '%',
			top: '50%', left: '50%',
			transform: `translate3d(-50%, -50%, 0) rotate(${ rotation }deg)`,
			zIndex: zIndex
		};
		const imgStyle = {
			position: 'absolute', top: 0, left: 0, 
			width: '100%', height: 'auto',
			display: 'block',
			pointerEvents: 'none',
		};
		return (
			<div className="StackItem" style={siStyle}>
				<Img style={imgStyle} src={src} width={width} height={height} alt="" />
			</div>
		);
	}
}

export default OverlapStack;


// WEBPACK FOOTER //
// ./src/components/Pages/Project/Chunks/Stacks/OverlapStack.jsx